export default {
    "header": require('./header.js'),
    "loader": require('./loader.js'),
    "garanties": require('./garanties.js'),
    "accordion": require('./accordion.js'),
    "faq": require('./faq.js'),
    "expertise": require('./expertise.js'),
}
